import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import DailyLog from "@/pages/DailyLog";
import Scorecard from "@/pages/Scorecard";
import Targets from "@/pages/Targets";
import Goals from "@/pages/Goals";
import Dues from "@/pages/Dues";
import Complaints from "@/pages/Complaints";
import MasterList from "@/pages/MasterList";
import AIAssistant from "@/pages/AIAssistant";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F172A]">
        <div className="text-[#C9A24B] font-heading animate-pulse text-xl">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/" state={{ from: location }} replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/daily-log" element={<DailyLog />} />
        <Route path="/scorecard" element={<Scorecard />} />
        <Route path="/targets" element={<Targets />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/dues" element={<Dues />} />
        <Route path="/complaints" element={<Complaints />} />
        <Route path="/master-list" element={<MasterList />} />
        <Route path="/ai-assistant" element={<AIAssistant />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
